import { render, staticRenderFns } from "./MngmtLinkSection.vue?vue&type=template&id=5d65b317&scoped=true"
import script from "./MngmtLinkSection.vue?vue&type=script&lang=js"
export * from "./MngmtLinkSection.vue?vue&type=script&lang=js"
import style0 from "./MngmtLinkSection.vue?vue&type=style&index=0&id=5d65b317&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d65b317",
  null
  
)

export default component.exports